import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-raleway text-white pl-8" }
const _hoisted_2 = { class: "flex flex-row my-4 mx-8 items-center relative" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "flex circle absolute justify-center items-center",
        style: `left: ${_ctx.computedScore}%`
      }, null, 4),
      (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
        return _createVNode("div", {
          key: i,
          class: "bg-white flex-grow h-3 mx-1 colour-block-cat"
        })
      }), 64 /* STABLE_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}